const playSound = (src: string) => {
  try {
    const audio = new Audio(src);
    audio.volume = 0.9;
    audio.play().catch(() => {});
  } catch {
  }
};

export const playSixSound = () => {
  try {
    playSound("/sounds/bat_hit.mp3");
    setTimeout(() => playSound("/sounds/ball_fly.mp3"), 200);
    setTimeout(() => playSound("/sounds/crowd_cheer.mp3"), 600);
  } catch {
  }
};

export const playFourSound = () => {
  try {
    playSound("/sounds/bat_hit.mp3");
    setTimeout(() => playSound("/sounds/ball_roll.mp3"), 300);
  } catch {
  }
};

export const playWicketSound = () => {
  try {
    playSound("/sounds/stumps_hit.mp3");
    setTimeout(() => playSound("/sounds/bails_fall.mp3"), 200);
    setTimeout(() => playSound("/sounds/howzat.mp3"), 500);
  } catch {
  }
};
